import { TabPanel } from "primereact/tabview";
import React from "react";
import styled from "styled-components";
import CvpTabView from "../../../Components/Tabs/CvpTabView";
import InboxTabContent from "./InboxTabContent";
import OutboxTabContent from "./OutboxTabContent";

export const MessageTabView: React.FC = ({}) => {
  return (
    <StyledMsgTabView className="cvp-message-tab-view">
      {messageTabs.map((tabs) => {
        const { header, content } = tabs;

        return (
          <TabPanel
            className="cvp-message-tab-panel"
            key={header}
            header={header}
          >
            <StyledTabContent className="cvp-tab-content">
              {content}
            </StyledTabContent>
          </TabPanel>
        );
      })}
    </StyledMsgTabView>
  );
};

export const StyledTabContent = styled.div`
  &.cvp-tab-content {
    display: flex;
    flex-direction: column;
    row-gap: 0.63rem;
  }
`;

export const StyledMsgTabView = styled(CvpTabView)`
  &.cvp-message-tab-view {
    &.p-tabview {
      .p-tabview-nav li {
        width: 50%;
      }

      .p-tabview-panels {
        background: transparent;
        padding: 2.35rem 0 0;
      }
    }
  }
`;

export const messageTabs = [
  {
    header: "Inboks",
    content: <InboxTabContent />,
  },
  {
    header: "Utboks",
    content: <OutboxTabContent />,
  },
];
